// Shared app store URLs — import from here instead of hardcoding in components
export const APP_LINKS = {
  googlePlay: "https://play.google.com/store/apps/details?id=com.entiresolutions.trendgenie",
  appStore: "https://apps.apple.com/us/app/trend-genie-ai-market-analysis/id6769978798",
};

export const SITE_URL = "https://www.trendgenie.io";
